import type {
  MoreVideoItemsResult,
  WorldRecommendationsResult,
} from '@/types/world-recommendations'

type QueryValue = string | number | undefined

const fetchWorldRecommendations = async <T>(
  worldId: string,
  endpoint: 'recommendations' | 'recommend-worlds' | 'more-videos',
  query: Record<string, QueryValue>,
): Promise<T> => {
  const searchParams = new URLSearchParams()

  for (const [key, value] of Object.entries(query)) {
    if (value !== undefined) searchParams.set(key, String(value))
  }

  const response = await fetch(
    `/api/worlds/${encodeURIComponent(worldId)}/${endpoint}?${searchParams}`,
    { cache: 'no-store' },
  )

  return response.json() as Promise<T>
}

export const fetchLogoOverlayRecommendations = ({
  worldId,
  ...query
}: {
  worldId: string
  contentTypeCode: string
  csdataBid?: string
  limit: number
}) => fetchWorldRecommendations<WorldRecommendationsResult>(worldId, 'recommendations', query)

export const fetchRecommendWorlds = ({
  worldId,
  ...query
}: {
  worldId: string
  variant: string
  limit: number
  contentTypeCode?: string
  csdataBid?: string
}) => fetchWorldRecommendations<WorldRecommendationsResult>(worldId, 'recommend-worlds', query)

export const fetchMoreVideoItems = ({
  worldId,
  ...query
}: {
  worldId: string
  csdataBid?: string
}) => fetchWorldRecommendations<MoreVideoItemsResult>(worldId, 'more-videos', query)
